export default "__VITE_ASSET__b06f8ba7__"